export default __webpack_public_path__ + "static/media/parking_icon.44b15168.png";